/**
 * MediaSource helper
 */

export function getMediaSource () {
  if (typeof window !== 'undefined') {
    return window.MediaSource || window.WebKitMediaSource;
  }
}
